import { jsx as e } from "react/jsx-runtime";
const r = (l) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...l,
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m14.5 11.097-1.5.405.398 1.498H1.5V3h13v8.097ZM13 4.5H3v7h10v-7Zm-1.757 1.142L9.5 6.13v2.743l.867-.233.585 1.719 1.156-3.67-.864.232V5.642ZM5.256 8.375H3.684a2.285 2.285 0 0 0 2.247 1.889v-1.5a.783.783 0 0 1-.675-.389Zm-1.579-.75a2.285 2.285 0 0 1 2.254-1.926 2.285 2.285 0 0 1 2.282 2.282h-1.5a.783.783 0 0 0-1.477-.356H3.677Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  r as SmartMeter
};
